import { httpClient } from '../http-client/http-client';

const GetPaginatedList = (endpoint, keyword, skipCount, maxResultCount) => {
  const keywordString = keyword !== null ? `Keyword=${keyword}&` : '';
  const url = `services/app/${endpoint}?${keywordString}SkipCount=${skipCount}&MaxResultCount=${maxResultCount}`;

  return httpClient.get(url).then(result => result.data.result.items);
};

export { GetPaginatedList };
